import { Fragment, useEffect, useState } from "react";
import Styles from "../../styles/report/performance.module.scss";
import { useSelector } from "react-redux";
import { getPerformanceSummary } from "../../services";

const Performance = () => {
  const { performance } = useSelector((state) => state.client);

  useEffect(() => {
    getPerformanceSummary();
  }, []);


  // State for filters
  const [selectedBlock, setSelectedBlock] = useState("");
  const [selectedWorkout, setSelectedWorkout] = useState("");
  const [mostImprovedBlock, setMostImprovedBlock] = useState("");
  const [maleBlock, setMaleBlock] = useState("");
  const [femaleBlock, setFemaleBlock] = useState("");

  // Create Most Improved Clients data
  const createMostImprovedData = (quarter) => {
    const improvedClients = performance?.topImprovedClients?.[quarter] || [];
    const data = [];

    for (let i = 0; i < 5; i++) {
      const client = improvedClients[i];
      if (
        client?.client?.name &&
        client?.score !== undefined &&
        client?.score !== null
      ) {
        data.push({
          name:
            client.client.name.length > 5
              ? client.client.name.slice(0, 4) + ".."
              : client.client.name,
          value: Math.max(0, Math.round(client.score)), // Ensure no negative values for chart display
        });
      } else {
        data.push({
          name: `Client ${i + 1}`,
          value: 0,
        });
      }
    }

    return data;
  };

  // Create Top In Category (Workout) data
  const createTopCategoryData = (quarter, workoutIndex = 0) => {
    const workouts = performance?.workouts || [];
    if (workouts.length === 0) return [];

    const selectedWorkoutData = workouts[workoutIndex];
    const topPerformers = selectedWorkoutData?.topPerformers?.[quarter] || [];
    const data = [];

    for (let i = 0; i < 5; i++) {
      const performer = topPerformers[i];
      if (
        performer?.client?.name &&
        performer?.score !== undefined &&
        performer?.score !== null
      ) {
        data.push({
          name:
            performer.client.name.length > 5
              ? performer.client.name.slice(0, 4) + ".."
              : performer.client.name,
          value: Math.round(performer.score),
        });
      } else {
        data.push({
          name: `Client ${i + 1}`,
          value: 0,
        });
      }
    }

    return data;
  };

  // Create gender-based data with quarter selection
  const createGenderData = (gender, quarter) => {
    const performers = performance?.topPerformers?.[gender]?.[quarter] || [];
    const genderData = [];

    for (let i = 0; i < 5; i++) {
      const performer = performers[i];
      if (
        performer?.client?.name &&
        performer?.score !== undefined &&
        performer?.score !== null
      ) {
        genderData.push({
          name:
            performer.client.name.length > 5
              ? performer.client.name.slice(0, 4) + ".."
              : performer.client.name,
          value: Math.round(performer?.score),
          hasData: true,
        });
      } else {
        genderData.push({
          name: "",
          value: 0,
          hasData: false,
        });
      }
    }

    return genderData;
  };

  // Get workout options for Top In Category filter
  const getWorkoutOptions = () => {
    return (
      performance?.workouts?.map((workout, index) => ({
        index,
        name: workout.workout.name,
      })) || []
    );
  };

  // Generate dynamic data
  const mostImprovedData = createMostImprovedData(mostImprovedBlock || "1");
  const selectedWorkoutIndex =
    selectedWorkout !== "" ? parseInt(selectedWorkout) : 0;
  const topCategoryData = createTopCategoryData(
    selectedBlock || "1",
    selectedWorkoutIndex
  );
  const femalePerformanceData = createGenderData(
    "female",
    femaleBlock || "1"
  );
  const malePerformanceData = createGenderData("male", maleBlock || "1");

  const maxValue = 800;
  const yAxisLabels = [800, 700, 600, 500, 400, 300, 200, 100, 0];
  const maxHorizontalValue = 400;
  const dynamicYear = performance?.year || new Date().getFullYear();

  const renderVerticalChart = (data, title, quarterState, setBlockState) => (
    <div className={Styles.chartContainer}>
      <div className={Styles.chartHeader}>
        <h3 className={Styles.chartTitle}>{title}</h3>
        <div className={Styles.filterDropdown}>
          <select
            className={Styles.filterSelect}
            value={quarterState}
            onChange={(e) => setBlockState(e.target.value)}
          >
            <option value="" disabled>
              Filter By Block
            </option>
            <option value="1">B1 {dynamicYear}</option>
            <option value="2">B2 {dynamicYear}</option>
            <option value="3">B3 {dynamicYear}</option>
            <option value="4">B4 {dynamicYear}</option>
          </select>
          <span className={Styles.dropdownIcon}>▼</span>
        </div>
      </div>
      <div className={Styles.chart}>
        <div className={Styles.yAxis}>
          {yAxisLabels.map((label, index) => (
            <div key={index} className={Styles.yAxisLabel}>
              {label}
            </div>
          ))}
        </div>
        <div className={Styles.chartContent}>
          <div className={Styles.gridLines}>
            {yAxisLabels.slice(0, -1).map((_, index) => (
              <div key={index} className={Styles.gridLine}></div>
            ))}
          </div>
          <div className={Styles.barsContainer}>
            {data.map((item, index) => (
              <div key={index} className={Styles.barWrapper}>
                <div
                  className={Styles.bar}
                  style={{ height: `${(item.value / maxValue) * 100}%` }}
                ></div>
                <div className={Styles.xAxisLabel}>{item.name}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  // Special render function for Top In Category with dual filters
  const renderTopInCategoryChart = (data, title) => {
    const workoutOptions = getWorkoutOptions();
    const currentWorkoutName =
      workoutOptions[selectedWorkoutIndex]?.name || "BENCH PRESS";
console.log(currentWorkoutName,"      fggfdfggf");

    return (
      <div className={Styles.chartContainer}>
        <div className={Styles.chartHeader}>
          <h3 className={Styles.chartTitle}>
            {title} - {currentWorkoutName}
          </h3>
          <div className={Styles.filtersContainer}>
            <div className={Styles.filterDropdown}>
              <select
                className={Styles.filterSelect}
                value={selectedBlock}
                onChange={(e) => setSelectedBlock(e.target.value)}
              >
                <option value="" disabled>
                  Filter By Block
                </option>
                <option value="1">B1 {dynamicYear}</option>
                <option value="2">B2 {dynamicYear}</option>
                <option value="3">B3 {dynamicYear}</option>
                <option value="4">B4 {dynamicYear}</option>
              </select>
              <span className={Styles.dropdownIcon}>▼</span>
            </div>
            <div className={Styles.filterDropdown}>
              <select
                className={Styles.filterSelect}
                value={selectedWorkout}
                onChange={(e) => setSelectedWorkout(e.target.value)}
              >
                <option value="" disabled>
                  Filter By Exercise
                </option>
                {workoutOptions.map((workout) => (
                  <option key={workout.index} value={workout.index}>
                    {workout.name}
                  </option>
                ))}
              </select>
              <span className={Styles.dropdownIcon}>▼</span>
            </div>
          </div>
        </div>
        <div className={Styles.chart}>
          <div className={Styles.yAxis}>
            {yAxisLabels.map((label, index) => (
              <div key={index} className={Styles.yAxisLabel}>
                {label}
              </div>
            ))}
          </div>
          <div className={Styles.chartContent}>
            <div className={Styles.gridLines}>
              {yAxisLabels.slice(0, -1).map((_, index) => (
                <div key={index} className={Styles.gridLine}></div>
              ))}
            </div>
            <div className={Styles.barsContainer}>
              {data.map((item, index) => (
                <div key={index} className={Styles.barWrapper}>
                  <div
                    className={Styles.bar}
                    style={{ height: `${(item.value / maxValue) * 100}%` }}
                  ></div>
                  <div className={Styles.xAxisLabel}>{item.name}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderHorizontalChart = (
    data,
    title,
    quarterState,
    setBlockState
  ) => {
    // Don't render chart if no valid data at all
    if (!data.some((item) => item.hasData)) {
      return (
        <div className={Styles.chartContainer}>
          <div className={Styles.chartHeader}>
            <h3 className={Styles.chartTitle}>{title}</h3>
            <div className={Styles.filterDropdown}>
              <select
                className={Styles.filterSelect}
                value={quarterState}
                onChange={(e) => setBlockState(e.target.value)}
              >
                <option value="" disabled>
                  Filter By Block
                </option>
                <option value="1">B1 {dynamicYear}</option>
                <option value="2">B2 {dynamicYear}</option>
                <option value="3">B3 {dynamicYear}</option>
                <option value="4">B4 {dynamicYear}</option>
              </select>
            </div>
          </div>
          <div
            className={Styles.noDataMessage}
            style={{
              color: "#ffffff",
              fontSize: "1rem",
              fontWeight: 500,
              margin: 0,
              textAlign: "center",
            }}
          >
            No data available for this quarter
          </div>
        </div>
      );
    }

    return (
      <div className={Styles.chartContainer}>
        <div className={Styles.chartHeader}>
          <h3 className={Styles.chartTitle}>{title}</h3>
          <div className={Styles.filterDropdown}>
            <select
              className={Styles.filterSelect}
              value={quarterState}
              onChange={(e) => setBlockState(e.target.value)}
            >
              <option value="" disabled>
                Filter By Block
              </option>

              <option value="1">B1 {dynamicYear}</option>
              <option value="2">B2 {dynamicYear}</option>
              <option value="3">B3 {dynamicYear}</option>
              <option value="4">B4 {dynamicYear}</option>
            </select>
            <span className={Styles.dropdownIcon}>▼</span>
          </div>
        </div>
        <div className={Styles.horizontalChart}>
          <div className={Styles.horizontalGridLines}>
            {[0, 1, 2, 3, 4].map((_, index) => (
              <div key={index} className={Styles.horizontalGridLine}></div>
            ))}
          </div>
          <div className={Styles.horizontalBarsContainer}>
            {data.map((item, index) => (
              <div key={index} className={Styles.horizontalBarRow}>
                <div className={Styles.horizontalLabel}>
                  {item.hasData ? item.name : ""}
                </div>
                <div className={Styles.horizontalBarTrack}>
                  <div
                    className={Styles.horizontalBar}
                    style={{
                      width: item.hasData
                        ? `${(item.value / maxHorizontalValue) * 100}%`
                        : "0%",
                      visibility: item.hasData ? "visible" : "hidden",
                    }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
          <div className={Styles.horizontalXAxis}>
            <span>0</span>
            <span>100</span>
            <span>200</span>
            <span>300</span>
            <span>400</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      <div className={Styles.dashboardContainer}>
        <div className={Styles.categoryContainer}>
          {renderVerticalChart(
            mostImprovedData,
            "Most Improved Clients",
            mostImprovedBlock,
            setMostImprovedBlock
          )}
          {renderTopInCategoryChart(topCategoryData, "Top In Category")}
        </div>
        <div className={Styles.categoryContainer}>
          {renderHorizontalChart(
            femalePerformanceData,
            "Top 5 Overall Performances - Female",
            femaleBlock,
            setFemaleBlock
          )}
          {renderHorizontalChart(
            malePerformanceData,
            "Top 5 Overall Performances - Male",
            maleBlock,
            setMaleBlock
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default Performance;
